
import Vue from 'vue';
import api from '@/api/api';
import ModalCrud from '@/components/ModalCrud.vue';
import { store } from '@/store';
import { M_MENU } from '@/store/mutations-types';
import { formsValidations } from '@/utils/formsValidations';

export default Vue.extend({
	name: 'ControleFinanceiroMovimentacao',
	data() {
		return {
			cards: {
				datasetHeader: {
					nome: '',
					saldoCartao: '',
					saldoDinheiro: '',
					ultFecha: '',
					dtUltFecha: ''
				},
				dataset: [],
				isLoading: false
			},
			fab: false,
			modals: {
				criarEditarLancamento: {
					isLoading: false,
					visible: false,
					title: ''
				},
				filtrarLancamentos: {
					isLoading: false,
					visible: false,
					title: 'Filtrar'
				},
				rateio: {
					isLoading: false,
					visible: false,
					title: 'Rateio'
				}
			},
			forms: {
				criarEditarLancamento: {
					data: {
						id: null,
						operador: '',
						operacao: '',
						idControleFinanceiro: '',
						valor: null,
						responsavel: '',
						obs: '',
						data: '',
						idCliente: null,
						idTipo: '',
						idStatus: 1,
						idCidade: null,
						rateio: {
							rateado: false,
							itens: []
						}
					},
					datasets: {
						tipos: [],
						clientes: [],
						colaboradores: [],
						cidades: []
					},
					controls: {
						isValid: true
					}
				},
				filtrarLancamentos: {
					controls: {
						isValid: true
					},
					data: {
						operacao: '',
						operador: '',
						responsavel: '',
						dataInicial: '',
						dataFinal: '',
						status: 'A'
					}
				},
				rateio: {
					data: {
						idColaborador: null,
						valor: null
					},
					controls: {
						isValid: true
					}
				}
			},
			search: '',
		};
	},
	computed: {
		checkMobileScreen() {
			const check = this.isMobile;
			return check;
		},
		filteredDataset() {
			let lowerSearch = this.search.toLowerCase();
			return this.cards.dataset.filter(x =>
				x.id.toString().includes(lowerSearch) ||
				x.data.toLowerCase().includes(lowerSearch) ||
				x.valor.toLowerCase().includes(lowerSearch) ||
				x.obs.toLowerCase().includes(lowerSearch) ||
				x.responsavel.toLowerCase().includes(lowerSearch) ||
				x.tipo.toLowerCase().includes(lowerSearch)
			)
		},
		cityIsRequired() {
			if (!this.forms.criarEditarLancamento.data.idTipo) return false;

			const tipo = this.forms.criarEditarLancamento.datasets.tipos.find((tipo) => {
				return tipo.id === this.forms.criarEditarLancamento.data.idTipo
			});

			return tipo?.obrigaCidade === 1;
		},
	},
	watch: {
		'forms.criarEditarLancamento.data.idCliente': function (newValue, oldValue) {
			if (!oldValue || !this.cityIsRequired || this.forms.criarEditarLancamento.data.operador !== 'D') return;
			
			if (newValue === oldValue &&
				this.forms.criarEditarLancamento.data.id &&
				this.forms.criarEditarLancamento.data.idCidade) return;

			const cliente = this.forms.criarEditarLancamento.datasets.clientes.find((cliente) => cliente.id === newValue);

			if (!cliente) return;

			this.forms.criarEditarLancamento.data.idCidade = cliente.idCidade;
		}
	},
	methods: {
		async showModalNewEdit(id) {
			try {
				let response;

				this.modals.criarEditarLancamento.isLoading = true;
				this.modals.criarEditarLancamento.visible = true;
				this.modals.criarEditarLancamento.title = id ? `${id} - Editar Lançamento ` : 'Novo lançamento';
				response = await api.get('/financial-control-batch-data');
				this.forms.criarEditarLancamento.datasets.tipos = response.data.tipos;
				this.forms.criarEditarLancamento.datasets.clientes = response.data.clientes;
				this.forms.criarEditarLancamento.datasets.colaboradores = response.data.colaboradores;
				this.forms.criarEditarLancamento.datasets.cidades = response.data.cidades;

				if (id) {
					response = await api.get(`/financial-control-batch/${id}`);
					this.forms.criarEditarLancamento.data = {
						id: id,
						operador: response.data.operador,
						operacao: response.data.operacao,
						idControleFinanceiro: response.data.idControleFinanceiro,
						valor: response.data.valor,
						responsavel: response.data.responsavel,
						obs: response.data.obs,
						data: response.data.data,
						idCliente: response.data.idCliente,
						idTipo: response.data.idTipo,
						idStatus: response.data.idStatus,
						idCidade: response.data.idCidade,
						rateio: {
							rateado: !!response.data.rateio.rateado,
							itens: response.data.rateio.itens
						}
					};
				} else {
					this.forms.criarEditarLancamento.data = {
						id: null,
						operador: '',
						operacao: '',
						idControleFinanceiro: '',
						valor: null,
						responsavel: '',
						obs: '',
						data: '',
						idCliente: null,
						idTipo: '',
						idStatus: 1,
						idCidade: null,
						rateio: {
							rateado: false,
							itens: []
						}
					};
					if (!(this.$store.state.infoUser.current.supervisor) && !(this.$store.state.infoUser.current.departamento === 4)) {
						this.forms.criarEditarLancamento.data.operador = 'D'
					}
				}
			}
			catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
			}
			finally {
				this.modals.criarEditarLancamento.isLoading = false;
			}
		},
		async showModalFiltrarLancamento() {
			try {
				this.modals.filtrarLancamentos.isLoading = true;
				this.modals.filtrarLancamentos.visible = true;
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
			} finally {
				this.modals.filtrarLancamentos.isLoading = false;
			}
		},
		async saveControleFinanceiroMovimentacao() {
			try {
				const formValidation = await this.$refs.formCriarEditar.validate();
				if (this.forms.criarEditarLancamento.data.operador !== 'F') {
					if (this.forms.criarEditarLancamento.data.responsavel !== 'C' && this.forms.criarEditarLancamento.data.responsavel !== 'E') throw new Error("Escolha um responsável!");

					if (this.forms.criarEditarLancamento.data.operacao !== 'C' && this.forms.criarEditarLancamento.data.operacao !== 'D') throw new Error("Escolha entre cartão e dinheiro.");

					if (this.forms.criarEditarLancamento.data.operador !== 'C' && this.forms.criarEditarLancamento.data.operador !== 'D') throw new Error("Escolha entre créditar ou debitar o lote.");
				};

				if (this.forms.criarEditarLancamento.data.valor <= 0) throw new Error("Valor deve ser maior que zero.");

				if (this.forms.criarEditarLancamento.data.rateio.rateado) {
					if (this.forms.criarEditarLancamento.data.rateio.itens.length === 0) throw new Error("Adicione colaboradores para rateio.");

					const sumOfItens = this.forms.criarEditarLancamento.data.rateio.itens.reduce((acc, item) => acc + item.valor, 0);
					if (sumOfItens !== this.forms.criarEditarLancamento.data.valor) {
						throw new Error("Valor total dos itens de rateio deve ser igual ao valor do lançamento.");
					};
				};

				if (formValidation) {
					this.modals.criarEditarLancamento.isLoading = true;
					this.forms.criarEditarLancamento.data.idControleFinanceiro = Number(this.$router.currentRoute.params.id);
					const [metodo, mensagem] = this.forms.criarEditarLancamento.data.id ? ['put', 'alterada'] : ['post', 'criada'];
					if (metodo === 'post') {
						const currentDate = new Date();
						const savingDate = new Date(this.forms.criarEditarLancamento.data.data);

						const sixtyDaysAgo = new Date(currentDate);
						sixtyDaysAgo.setDate(currentDate.getDate() - 60);
						if (savingDate < currentDate && savingDate <= sixtyDaysAgo) {
							throw new Error("Lançamento com mais de 60 dias para trás não são permitidos");
						} else if (savingDate > currentDate) {
							throw new Error("Lançamento com data futura não são permitidos");
						};
					};
					
					await api[metodo]('/financial-control-batch', this.forms.criarEditarLancamento.data);
					this.$toast.success(`Movimentação ${mensagem} com sucesso!`);
					this.modals.criarEditarLancamento.visible = false;
					await this.loadData();
				} else {
					throw new Error("Formulário inválido.")
				}
			}
			catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
			}
			finally {
				this.modals.criarEditarLancamento.isLoading = false;
			}
		},
		async saveRateio() {
			try {
				this.modals.rateio.isLoading = true;
				const formValidation = await this.$refs.formRateio.validate();

				if (formValidation) {
					if (this.forms.rateio.data.valor <= 0) {
						throw new Error("Valor do rateio deve ser maior que zero.");
					};

					const sumOfItens = this.forms.criarEditarLancamento.data.rateio.itens.reduce((acc, item) => acc + item.valor, 0);
					if ((sumOfItens + this.forms.rateio.data.valor) > this.forms.criarEditarLancamento.data.valor) {
						throw new Error("Valor total dos itens de rateio não pode ser maior que o valor do lançamento.");
					};
					this.forms.criarEditarLancamento.data.rateio.itens.push({
						idColaborador: this.forms.rateio.data.idColaborador,
						valor: this.forms.rateio.data.valor
					});

					this.modals.rateio.visible = false;
					this.forms.rateio.data = {
						idColaborador: null,
						valor: null
					};
				} else {
					throw new Error("Formulário inválido.")
				};
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
			} finally {
				this.modals.rateio.isLoading = false;
			}
		},
		destroyModalRateio() {
			this.forms.rateio.data = {
				idColaborador: null,
				valor: null
			};
			this.modals.rateio.visible = false;
		},
		async handleFilter() {
			try {
				this.modals.filtrarLancamentos.isLoading = true;
				await this.loadData();
				this.modals.filtrarLancamentos.visible = false;
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha ao filtrar dados.')
			} finally {
				this.modals.filtrarLancamentos.isLoading = false;
			}
		},
		async loadData() {
			try {
				this.cards.isLoading = true;
				const { data } = await api.get(`/financial-control-batch?idLote=${this.$router.currentRoute.params.id}${this.gerarQueryString() ? `&${this.gerarQueryString()}` :
					''}`);
				this.cards.dataset = data.data;
				this.cards.datasetHeader = {
					...data.dataLote
				};
				store.commit(M_MENU, `Controle Financeiro - Lote ${data.dataLote.nome}`);
			} catch (err) {
				console.log(err)
				this.$toast.error("Falha ao comunicar com o banco de dados!");
			} finally {
				this.cards.isLoading = false;
			}
		},
		async activeInactive(id, idStatus) {
			try {
				await api.patch(`/financial-control-batch/${id}`);

				await this.loadData();

				this.$toast.success(`Registro ${idStatus === 'A' ? 'inativado' : 'reativado'} com sucesso!`)
			}
			catch (error) {
				this.$toast.error(error.message ?? 'Falha na comunicação');
			}
		},
		destroyModalNewEdit() {
			this.forms.criarEditarLancamento.data = {
				id: null,
				operador: '',
				operacao: '',
				idControleFinanceiro: '',
				valor: null,
				responsavel: '',
				obs: '',
				data: '',
				idCliente: null,
				idTipo: '',
				idStatus: 1,
				idCidade: null,
				rateio: {
					rateado: false,
					itens: []
				}
			};
			this.modals.criarEditarLancamento.visible = false;
			this.forms.criarEditarLancamento.datasets = {
				tipos: [],
				clientes: [],
				colaboradores: [],
				cidades: []
			};
		},
		async xlsxExport() {
			try {
				const prepareData = this.filteredDataset.map(x => {
					let operacao = '';
					switch (x.operacao) {
						case 'C':
							operacao = 'Cartão';
							break;
						case 'D':
							operacao = 'Dinheiro';
							break;
						default:
							operacao = 'Fechamento';
							break;
					};
					return {
						operador: x.operador === 'C' ? 'Crédito' : 'Débito',
						operacao: operacao,
						data: x.data,
						valor: Number(x.valor.replaceAll('.', '#').replaceAll(',', '.').replaceAll('#', '')),
						tipo: x.tipo,
						responsavel: x.responsavel,
						obs: x.obs,
						idStatus: x.idStatus === 'A' ? 'Ativo' : 'Inativo'
					}
				})

				const { XlsxExport } = await import('@/utils/xlsxExport');

				let instanceExport = new XlsxExport({
					columns: [
						{
							name: 'operador',
							label: 'Operador',
						},
						{
							name: 'operacao',
							label: 'Operação',
						},
						{
							name: 'data',
							label: 'Data',
							isDate: true,
						},
						{
							name: 'valor',
							label: 'Valor',
							isCurrency: true
						},
						{
							name: 'tipo',
							label: 'Tipo'
						},
						{
							name: 'responsavel',
							label: 'Resp.'
						},
						{
							name: 'obs',
							label: 'Obs.'
						},
						{
							name: 'idStatus',
							label: 'Status'
						}
					],
					data: prepareData,
					title: `Controle Fin. ${this.cards.datasetHeader.nome}`
				});
				await instanceExport.export();
				instanceExport = null;
			} catch (error) {
				this.$toast.error(error.message ?? 'Falha ao comunicar com o banco de dados!');
			}
		},
		gerarQueryString() {
			const query = Object.keys(this.forms.filtrarLancamentos.data)
				.filter(key => this.forms.filtrarLancamentos.data[key] !== '' && this.forms.filtrarLancamentos.data[key] !== null && this.forms.filtrarLancamentos.data[key] !== undefined)
				.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.forms.filtrarLancamentos.data[key]))
				.join('&');

			return query;
		},
	},
	async mounted() {
		await this.loadData();
	},
	setup() {
		return {
			formsValidations
		}
	},
	components: { ModalCrud }
})

